import { SegmentedControl, Tooltip } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { GrowthOverviewGranularity, GROWTH_OVERVIEW_QUERY_KEY, GrowthOverviewMetric } from "../const";
import { useGrowthOverviewContext } from "../context/GrowthOverviewProvider";
import { GROWTH_OVERVIEW_I18N_KEYS } from "../growthOverviewTexts";

export const GranularitySwitcher = () => {
    const { granularity, setGranularity, isQuarterlyEnabled, metric } = useGrowthOverviewContext();

    const quarterlyDisabledTooltip =
        metric === GrowthOverviewMetric.Unique
            ? translate(GROWTH_OVERVIEW_I18N_KEYS.granularity.quarterlyDisabledUnique)
            : translate(GROWTH_OVERVIEW_I18N_KEYS.granularity.quarterlyDisabled);

    return (
        <Flex data-automation={`${GROWTH_OVERVIEW_QUERY_KEY}-granularity-switcher`}>
            <SegmentedControl
                value={granularity}
                onValueChange={(value) => setGranularity(value as GrowthOverviewGranularity)}
            >
                <SegmentedControl.Item
                    value={GrowthOverviewGranularity.Weekly}
                    label={translate(GROWTH_OVERVIEW_I18N_KEYS.granularity.weekly)}
                />
                <SegmentedControl.Item
                    value={GrowthOverviewGranularity.Monthly}
                    label={translate(GROWTH_OVERVIEW_I18N_KEYS.granularity.monthly)}
                />
                <Tooltip
                    placement="top"
                    content={quarterlyDisabledTooltip}
                    enabled={!isQuarterlyEnabled}
                >
                    <SegmentedControl.Item
                        value={GrowthOverviewGranularity.Quarterly}
                        label={translate(GROWTH_OVERVIEW_I18N_KEYS.granularity.quarterly)}
                        disabled={!isQuarterlyEnabled}
                    />
                </Tooltip>
            </SegmentedControl>
        </Flex>
    );
};
